export default __webpack_public_path__ + "static/media/queued-icon.0779f4c3.svg";